module.exports = __webpack_public_path__ + "static/media/2012_GDP_totalRate.ec39d0a1.png";